// extracted by mini-css-extract-plugin
export default {"textarea":"chatbot_textarea__jitwX"};